import React from "react"
import styled, {css} from "styled-components"
import Flex from "@irati/ui/src/Flex"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Markdown from "@irati/ui/src/Markdown"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {InjectIntl, injectIntl} from "@irati/utils/lang"
import RewardPointsIcon from "@irati/ui/images/reward_point.svg"

const Expire = styled(Flex)`
  align-items: center;
  cursor: pointer;
  width: fit-content;

  ${({theme}) => css`
    padding: ${theme.spacing.half};
    gap: ${theme.spacing.one};
    background-color: ${theme.colors.greys.graphGrey};
    border-radius: ${theme.border.radius.medium};
  `};

  .admin-wallet--expirary p {
    margin: 0;
  }
`

interface Props extends InjectIntl {
  onClick(): void
  amount: number
  date: string
}

function ExpiryComp({onClick, formatMessage, intl, amount, date}: Props) {
  const {colors} = useTheme()

  return (
    <Expire onClick={onClick}>
      <img alt="" src={RewardPointsIcon} width="18px" />
      <Markdown
        className="admin-wallet--expirary"
        source={formatMessage(
          {id: "wallet.reward.budget.rewardWallet.expirary"},
          {
            amount: intl.formatNumber(amount / 100),
            date: date
          }
        )}
      />
      <Icon color={colors.utility.ink} icon={IconTypes.circleInformation} large marginLeft={0.5} />
    </Expire>
  )
}

export default injectIntl(ExpiryComp)
